import { useConfig } from "../hooks/useConfig";
import { createTokens } from "@shopify-multiseller/common/tokens";

export function useTokens() {
    const config = useConfig();
    return createTokens(config?.shopConfig?.content);
}
